import { render } from "./settingsPage.vue?vue&type=template&id=c5045588&scoped=true"
import script from "./settingsPage.vue?vue&type=script&lang=js"
export * from "./settingsPage.vue?vue&type=script&lang=js"

import "./settingsPage.vue?vue&type=style&index=0&id=c5045588&scoped=true&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5045588"]])

export default __exports__